import { ref } from 'vue';
import {
  checkSubscription,
  getSubscriptionData,
  submitSubscription,
  cancelSubscription,
} from './../../js/api/subscription.api';

export function useSubscription(customer) {
  const isLoading = ref(false);
  const error = ref('');
  const editMode = ref(false);
  const subscriptionData = ref(null);

  const init = async () => {
    isLoading.value = true;
    error.value = '';

    try {
      const res = await checkSubscription(customer.id);
      const exists = !!(
        res?.exists ??
        res?.data?.exists ??
        res?.data?.subscription
      );

      if (exists) {
        editMode.value = true;
        subscriptionData.value = await getSubscriptionData(customer.id);
      } else {
        editMode.value = false;
        subscriptionData.value = null;
      }
    } catch (e) {
      error.value = e?.data?.message || e.message || 'Error';
    } finally {
      isLoading.value = false;
    }
  };

  const loadCurrentSubscription = async () => {
    isLoading.value = true;
    error.value = '';

    try {
      const res = await getSubscriptionData(customer.id);
      const subscription = res?.data?.subscription ?? null;

      subscriptionData.value = res;
      editMode.value = !!subscription;

      return res;
    } catch (e) {
      subscriptionData.value = null;
      editMode.value = false;
      error.value = e?.data?.message || e.message || 'Error';
      throw e;
    } finally {
      isLoading.value = false;
    }
  };

  const submit = async (payload) => {
    isLoading.value = true;
    error.value = '';

    try {
      const mode = editMode.value ? 'update' : 'create';
      return await submitSubscription(mode, payload);
    } catch (e) {
      error.value = e?.data?.message || e.message || 'Submit error';
      throw e;
    } finally {
      isLoading.value = false;
    }
  };

  const cancel = async () => {
    isLoading.value = true;
    error.value = '';

    try {
      const res = await cancelSubscription(customer.id);
      editMode.value = false;
      subscriptionData.value = null;

      return res;
    } catch (e) {
      error.value = e?.data?.message || e.message || 'Cancel error';
      throw e;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    error,
    editMode,
    subscriptionData,
    init,
    loadCurrentSubscription,
    submit,
    cancel,
  };
}